var $3a572e5fc81706d7$exports = {};
$3a572e5fc81706d7$exports = {
  "backButton": args => "Sp\xE4\u0165 na ".concat(args.prevMenuButton),
  "moreActions": "\u010Eal\u0161ie akcie",
  "unavailable": "Nedostupn\xE9, rozba\u013Ete podrobnosti"
};
export { $3a572e5fc81706d7$exports as default };